module.exports = __webpack_public_path__ + "img/feature_buy_zh.73b9e011.png";